@if (initialLoading()) {
<div class="flex items-center justify-center py-12">
  <div
    data-testid="pos-shift-open-form-loading"
    class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
  ></div>
</div>
} @else {
<app-add-form
  data-testid="pos-shift-open-form"
  [title]="config.title"
  [formFields]="translatedFormFields()"
  [headerActions]="config.headerActions"
  [editMode]="editMode"
  [viewMode]="viewMode"
  [initialData]="combinedInitialData()"
  (formAction)="onFormAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
></app-add-form>
}

<!-- Toast Messages -->
<p-toast data-testid="pos-shift-open-form-toast"></p-toast>
